import { SignInIdentifier } from '@logto/schemas';
import { useCallback, useContext } from 'react';

import UserInteractionContext from '@/Providers/UserInteractionContextProvider/UserInteractionContext';
import { UserFlow } from '@/types';

import useNavigateWithPreservedSearchParams from './use-navigate-with-preserved-search-params';

/**
 * Sends an account that has no password yet to ForgotPassword, with the email pre-filled:
 * setting the password there finishes setting up the account.
 */
const useNavigateToAccountSetup = () => {
  const navigate = useNavigateWithPreservedSearchParams();
  const { setForgotPasswordIdentifierInputValue } = useContext(UserInteractionContext);

  return useCallback(
    (email: string, { replace }: { replace?: boolean } = {}) => {
      setForgotPasswordIdentifierInputValue({ type: SignInIdentifier.Email, value: email });

      // Matches `accountSetupStateGuard`, which the ForgotPassword page reads.
      navigate(
        { pathname: `/${UserFlow.ForgotPassword}` },
        { replace, state: { isAccountSetup: true } }
      );
    },
    [navigate, setForgotPasswordIdentifierInputValue]
  );
};

export default useNavigateToAccountSetup;
